import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
// Ducks
// Styles
import "./SmartNotification.css";
import { compose } from "redux";
import { withNamespaces } from "react-i18next";
import { clearNotification } from "./SmartNotification.ducks";

class SmartNotification extends Component {
  componentDidUpdate() {
    const { notifications } = this.props;

    notifications.forEach(({ cancelAction, confirmAction, id }) => {
      const hasConfirmAction = typeof confirmAction === "function";
      const hasCancelAction = typeof cancelAction === "function";

      if (!hasCancelAction && !hasConfirmAction) {
        setTimeout(this.handleCloseNotification(id), 6000);
      }
    });
  }

  getNotificationFromId = (id) =>
    this.props.notifications.find((notification) => notification.id === id);

  handleCancelAction = (id) => () => {
    const { cancelAction } = this.getNotificationFromId(id);

    cancelAction && cancelAction();
    this.handleCloseNotification(id)();
  };

  handleConfirmAction = (id) => () => {
    const { confirmAction } = this.getNotificationFromId(id);

    confirmAction && confirmAction();
    this.handleCloseNotification(id)();
  };

  handleCloseNotification = (id) => () => {
    const { clearNotification } = this.props;

    clearNotification(id);
  };

  render() {
    const { notifications, t } = this.props;

    return (
      <div id="divSmallBoxes">
        {notifications.map((notification, index) => {
          const {
            cancelLabel,
            confirmLabel,
            id,
            messageTranslationKey,
            titleTranslationKey,
            type
          } = notification;

          return (
            <div
              key={id}
              className={classNames(
                "smart-notification",
                "alert",
                "alert-block",
                "animated",
                "fadeInRight",
                "fast",
                {
                  "alert-danger": type === "error",
                  "alert-info": type === "info",
                  "alert-success": type === "success",
                  "alert-warning": type === "warning",
                  "mt-20": !index
                }
              )}
            >
              <div className="header">
                <h4>{t(titleTranslationKey)}</h4>
                <a className="close" data-dismiss="alert" onClick={this.handleCancelAction(id)}>
                  &times;
                </a>
              </div>
              <p>{t(messageTranslationKey)}</p>
              <p className="text-align-right">
                {Boolean(confirmLabel) && (
                  <button
                    className="btn btn-primary btn-sm mr-1"
                    onClick={this.handleConfirmAction(id)}
                  >
                    {t(confirmLabel)}
                  </button>
                )}
                {Boolean(cancelLabel) && (
                  <button className="btn btn-danger btn-sm" onClick={this.handleCancelAction(id)}>
                    {t(cancelLabel)}
                  </button>
                )}
              </p>
            </div>
          );
        })}
      </div>
    );
  }
}

SmartNotification.propTypes = {
  clearNotification: PropTypes.func.isRequired,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      cancelAction: PropTypes.func,
      cancelLabel: PropTypes.string,
      confirmAction: PropTypes.func,
      confirmLabel: PropTypes.string,
      messageTranslationKey: PropTypes.string,
      titleTranslationKey: PropTypes.string,
      type: PropTypes.oneOf(["error", "info", "success", "warning"])
    })
  ),
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  ...state.smartNotification
});

const mapDispatchToProps = { clearNotification };

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(SmartNotification);
